<template lang="pug">
  div.classifier.standarts
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :hideSearch="true"
      :showYear="false"
      :showActual="true"
      :showCol="false"
      :showViewPanel="false"
        :showTotal="true"
        :hideImportBtn="true"
    )
    e-table(
      :items="items"
      :showCheckbox="false"
        @deleteItem="deleteItem"
        @editItem="editItem"
    )

    router-view
</template>

<script>
import {access, garbage, standarts, threads} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"
  import url from "../../utils/url";

  export default {
    mixins: [tableMixin],
    methods: {
      getEndpoint (route, fromRoute) {
        let deepCopyRoute = url.getRoute(route)
        return standarts.userAll(deepCopyRoute)
      },
      getDeleteUrl (id){
        return garbage.garbageCategoryDelete(id)
      },

      // asyncData ({store, route, fromRoute, methods}) {
      //   // if open modal
      //   if (fromRoute) {
      //     let jsonRoute = url.getRoute(fromRoute, true)
      //
      //     if (route.query.prevRoute && route.query.prevRoute === jsonRoute) {
      //       return Promise.resolve(1)
      //     }
      //   }
      //
      //   let promises = []
      //   promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getEndpoint(route, fromRoute)}))
      //   promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getCollectionEndpoint()}))
      //
      //   return Promise.all(promises)
      // }

    },
  };
</script>
